<template>
	<section>
		<div class="text-center w-75 m-auto">
			<h4 class="text-dark-50 text-center mt-0 font-weight-bold">Recuperar senha</h4>
		</div>

		<div class="form-group">
			<div class="field">
				<input type="password" id="txtSenha" class="input" v-model="params.senha" autofocus placeholder="Digite a nova senha">
				<label for="txtSenha" class="label">Senha</label>
			</div>
		</div>

		<div class="form-group">
			<div class="field">
				<input type="password" id="txtSenha" class="input" v-model="params.resenha" autofocus placeholder="Confirme a nova senha">
				<label for="txtSenha" class="label">Repetir senha</label>
			</div>
		</div>

		<div class="form-group mb-0 text-center">
			<button class="btn btn-sm btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2" type="submit" @click="submit">Enviar</button>
		</div>  
	</section>
</template>

<script>
	import api from '@/mixins/api.js'

	export default {
		name: "Password",
		mixins: [api],
		props: [ "user" ],
		components: { alert },

		data() { return { params: {} }},

		methods: {
			async submit() {
				if ( this.params.senha && this.params.resenha ) {
					if ( this.params.senha == this.params.resenha ) {
						this.user.password = this.params.senha
						this.send()
					}

					else window.alert("As senhas não são iguais.")
					
				}

				else window.alert("Preencha os campos de senha e repetir senha.")
			},

			async send() {
				const response = await this.PUT("User/Pwd", this.user)
				
				window.alert(response.result)

				if ( response.status == "success" ) {
					this.$router.push("/Login")
				}
			}
		}
	}
</script>

<style lang="scss">
	@import "../../../assets/sass/login.scss";
</style>